<template lang="pug">
    div
        v-menu(v-model='openEditDialog' :nudge-width='400' absolute :close-on-content-click="false")
            template(v-slot:activator='{ on, attrs }')
                div(v-bind='attrs' v-on='on')
                    v-list-item.text-center.profile()
                        v-list-item-content
                            v-list-item-title.title.text-wrap(style="margin-top:10px;")
                                h2 {{profile.name}}
                            v-list-item-subtitle.text-wrap
                                h3.black--text {{profile.tagline}} 
                    v-list-item.text-center.profile()
                        v-list-item-content
                            v-list-item-subtitle.text-wrap
                                h4.font-weight-regular {{profile.bio}}
                            v-list-item-subtitle.text-wrap
                                h4.font-weight-regular {{profile.location}}
                    v-list-item.text-center.desc()
                        v-list-item-content
                            v-list-item-subtitle.text-wrap
                                h4.font-weight-regular {{profile.description}}
            v-card
                v-card-title.font-weight-bold.mt-n1 Update Profile
                v-card-text.my-n2
                    v-row.px-3
                        v-text-field(
                            v-model="newName"
                            outlined
                            label="Name"
                        )
                    v-row.px-3
                        v-text-field(v-model="newTagline" outlined label="Tagline")
                    v-row.px-3
                        v-textarea(rows="3" v-model="newBio" outlined label="Biodata")
                    v-row.px-3
                        v-text-field(v-model="newLocation" outlined label="Location")
                    v-row.px-3
                        //- v-textarea(rows="3" counter maxlength="160" v-model="newDesc" outlined label="Description")
                        v-textarea(rows="3" v-model="newDesc" outlined label="Description")
                v-card-actions
                    v-spacer
                    v-btn.mb-2(small text @click.native="openEditDialog = false; newName = profile.name; newTagline = profile.tagline; newBio = profile.bio; newDesc = profile.description; newLocation = profile.location;") Cancel
                    v-btn.mb-2.mr-2(small depressed dark color="accent" @click="changeText()") Update
</template>
<script>
export default {
    props:['profile'],
    data: () => ({
        openEditDialog: false,
        newName: '',
        newTagline: '',
        newLocation: '',
        newBio: '',
        newDesc: ''
    }),
    mounted () {
        this.newName = this.profile.name,
        this.newTagline = this.profile.tagline,
        this.newLocation = this.profile.location,
        this.newBio = this.profile.bio,
        this.newDesc = this.profile.description
    },
    methods: {
        changeText () {
            this.profile.name = this.newName,
            this.profile.tagline = this.newTagline,
            this.profile.location = this.newLocation,
            this.profile.bio = this.newBio,
            this.profile.description = this.newDesc,
            this.openEditDialog = false
        }
    }
}
</script>
<style scoped>
 .profile{
    width: 300px;
    margin-left: auto;
    margin-right: auto;
 }
 .desc{
    width: 100%;
    padding: 0 20px;
    margin-left: auto;
    margin-right: auto;
 }
</style>